import React, { useEffect, useState } from 'react'
import { Button, ButtonToolbar, Col, FlexboxGrid, Grid, Icon, Panel, Row } from 'rsuite'
import { thaiDUpdateData } from '../../../redux/actions/thaid'
import { useHistory } from 'react-router-dom'
import { isEmpty } from 'lodash-es'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { DEFAULT_ERR_MSG } from '../../../constants/msgText'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'

export default function ResultIdentity() {
  const [resultStatus, setResultStatus] = useState()
  const [error, setError] = useState()
  const [isLoading, setIsLoading] = useState()

  const history = useHistory()

  const _styles = {
    panel: {
      backgroundColor: '#34a888',
    },
    titleMesage: {
      color: '#ffffff',
    },
    content: {
      marginTop: 20,
    },
    icon: {
      paddingRight: 10,
    },
    footer: {
      marginTop: 15,
    },
    button: {
      width: 120,
      color: '#ffffff',
      backgroundColor: '#575757',
      fontWeight: 'bold',
      fontSize: '14 !important',
    },
  }

  useEffect(() => {
    let parameters = location.search.substring(1)?.split('&')

    let params = []

    parameters.forEach((item) => {
      var items = item?.split('=')
      if (items.length == 2) {
        params.push({ name: items[0], value: items[1] })
      }
    })

    var code = params.find((e) => e.name == 'code' && !isEmpty(e.value)) || null
    var state = params.find((e) => e.name == 'state' && !isEmpty(e.value)) || null

    // console.log('code => ', code)
    // console.log('state => ', state)

    if (state && code) {
      callApi({ refCode: state.value, code: code.value })
    } else {
      setError({})
    }
  }, [])

  const callApi = async (request) => {
    setIsLoading(true)
    try {
      const result = await thaiDUpdateData(request)
      if (result.success) {
        setResultStatus(result)
      } else {
        setError({})
      }
    } catch (e) {
      setError({ errorMessage: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG })
    }
    setIsLoading(false)
  }

  if (error) {
    return <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
  }

  if (isLoading) {
    return (
      <div style={{ padding: 40 }}>
        <OverlayLoader />
        <PanalLoadingTemplate />
      </div>
    )
  }

  return (
    <>
      <Grid className="page-home">
        <Row>
          <FlexboxGrid align="middle" className="banner">
            <FlexboxGrid.Item componentClass={Col} colspan={7} md={6}></FlexboxGrid.Item>
            <FlexboxGrid.Item componentClass={Col} colspan={9} md={12}>
              <Panel bordered shaded>
                <div style={{ color: '#34a888' }}>
                  <Row>
                    <Col xs={24} md={24} lg={24} style={{ textAlign: 'center' }}>
                      <Icon icon={'check-circle'} size="5x" />
                      <h4>ยืนยันสำเร็จ</h4>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={24} md={24} lg={24} style={{ textAlign: 'center' }}>
                      <hr />

                      {!isEmpty(resultStatus?.redirectUri) ? (
                        <>
                          <Button
                            appearance="primary"
                            onClick={() => {
                              sessionStorage.setItem('projectId', resultStatus.projectVersionId)
                              history.push({
                                pathname: `${resultStatus.redirectUri}`,
                              })
                            }}
                          >
                            ไปหน้าดำเนินการ
                          </Button>
                        </>
                      ) : (
                        <>
                          <span>สามาถปิดหน้าต่างนี้ได้เลย</span>
                          {/* <Button
                              appearance="primary"
                              onClick={() => {
                                window.location.href = '/'
                                // window.opener = null
                                // window.open('', '_self')
                                // window.close()
                              }}
                            >
                              ปิดหน้าต่าง
                            </Button> */}
                        </>
                      )}
                    </Col>
                  </Row>
                </div>
              </Panel>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item componentClass={Col} colspan={7} md={6}></FlexboxGrid.Item>
          </FlexboxGrid>
        </Row>
      </Grid>
    </>
  )
}
